import React, {useEffect, useState} from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, Typography, InputLabel, Select, MenuItem, FormControl } from "@mui/material"
import style from "./style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import color from "../../../../../constants/color"
import SubHeader from "../../../../../components/SubHeader"
import StatementGenarateList from "./StatementList";
import {ReactComponent as Download}from "../../../../../assets/ViewLeave-images/download.svg";
import { ReactComponent as Cash } from "../../../../../assets/invoice/tdesign_money.svg";
import { ReactComponent as Bank } from "../../../../../assets/invoice/mingcute_bank-line.svg";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
// import dayjs from "dayjs";

// import { useNavigate } from "react-router-dom";


const StatementGenarate = ({data, total,page,setPage,banks, getStatementGenerate,success,handleDownload}) => {

  const [start, setStart] = useState(() => dayjs().startOf("month"));
  const [end, setEnd] = useState(() => dayjs().endOf("month"));
  const [account, setAccount] = useState()
  const [type, setType] = useState("Revenue")

  useEffect(()=>{
    const defaultAccount = banks?.find(bank => bank?.isDefault)?.name || "";
    setAccount(defaultAccount)
    if(account){
      getStatementGenerate(start, end, account,type)
    }
  },[banks])

  return (
    <>
      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Account Statement Generate</Typography>
          <Box display="flex" justifyContent={{ xs: "start", md: "end" }} alignItems={{ xs: "start", md: "end" }} mt={{xs:2, md: 0}}>
            <Button variant="contained" color="success" sx={style.csvBtns} onClick={() => handleDownload(start,end,type,account,"csv")} ><Download />
              {"CSV"}
            </Button>

            <Button variant="contained" color="success" sx={style.checkinBtns} onClick={() => handleDownload(start,end,type,account,"pdf")} ><Download />
              {"Export PDF"}
            </Button>


          </Box>
        </Box>


      </Box>
      <form>

        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            <Box sx={style.inputSection}>

              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>Start Month</InputLabel>
                  <DatePicker sx={style.dateInput}
                    value={start}
                    onChange={(newValue) => {setStart(newValue);}}
                    maxDate={end}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }} />
                </LocalizationProvider>

              </Box>
              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>End Month</InputLabel>
                  <DatePicker sx={style.dateInput}
                    value={end}
                    onChange={(newValue) => {setEnd(newValue);}}
                    minDate={start}
                    slotProps={{
                      field: {
                        readOnly: true
                      }
                    }} />
                </LocalizationProvider>              </Box>
              <Box sx={style.inputBox}>
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "2.5em",
                      marginTop: "0.5em",
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Typography sx={style.inputText}>Type</Typography>
                  <Select
                    value={type || ""}
                    onChange={(event) =>{
                      setType(event.target.value)
                    }
                    }
                    name="type"
                    sx={style.dropDownMenu}
                    displayEmpty
                  >
                    <MenuItem disabled value="">
                                            Select
                    </MenuItem>
                    <MenuItem value="Revenue">Revenue</MenuItem>
                    <MenuItem value="Purchase">Purchase</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Box sx={style.inputBox}>
                <FormControl
                  fullWidth
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      height: "2.5em",
                      marginTop: "0.5em",
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Typography sx={style.inputText}>Bank</Typography>
                  <Select
                    value={account || ""}
                    onChange={(event) =>{
                      setAccount(event.target.value)
                    }
                    }
                    name="bankDetails"
                    sx={style.dropDownMenu}
                    displayEmpty
                  >
                    <MenuItem disabled value="">
                                 Select
                    </MenuItem>
                    {banks?.map((bank, index) => (
                      <MenuItem key={index} value={bank.name}>
                        {`${bank.name.toUpperCase()} - ${bank.accountNumber.slice(
                          -4
                        )}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={style.createJob}>
                <Button variant="contained" color="success" disabled={!start || !end || !account || !type} sx={style.jobButtons} onClick={() => getStatementGenerate(start, end, account,type)}>
                          Apply Filter
                </Button>
              </Box>

            </Box>
          </Grid>

          <Grid container spacing={2} px="15px">
            <Grid item md={4} xs={12}>
              <Box sx={style.card}>
                <Box>
                  <Typography sx={style.textHeading}>Report</Typography> <Typography sx={style.textBody}>Account Statement </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={style.card}>
                <Box>
                  <Typography sx={style.textHeading}>Type</Typography> <Typography sx={style.textBody}>{type}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={style.card}>
                <Box>
                  <Typography sx={style.textHeading}>Duration</Typography> <Typography sx={style.textBody}>{start ? start?.format("DD-MMM-YYYY") : "Start Date"} to {end ? end?.format("DD-MMM-YYYY") : "End Date"}</Typography>
                </Box>
              </Box>
            </Grid>


          </Grid>
          <Grid container spacing={2} px="15px">
            <Grid item md={4} xs={12}>
              <Box sx={style.cardBox}>
                <Box sx={style.iconSection}>
                  <Cash style={style.dollarIcon} />
                </Box>
                <Box>
                  <Typography sx={style.textHeading}>Total</Typography> <Typography sx={style.textNumber}>{success ? (data?.Revenue?.toFixed(2)|| data?.totalAmount?.toFixed(2)) : 0}</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item md={4} xs={12}>
              <Box sx={style.cardBox}>
                <Box sx={style.bankSection}>
                  <Bank style={style.dollarIcon} />
                </Box>

                <Box>
                  <Typography sx={style.textHeading}>Bank</Typography> <Typography sx={style.textNumber}>{account}</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>

      </form>
      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <SubHeader
          isShow={false}
          sortBy="true"
          handleSort={(e)=>getStatementGenerate(start,end,account,type,e)} />

      
        <StatementGenarateList page={page} success={success} total={total} setPage={setPage} data={data}/>
    

      </Box>

    </>
  )
}
export default StatementGenarate;
